import { Tooltip, Button, Stack } from '@mui/material';
import { useCommunityDetails } from 'atoms/community-details';
import FlexRow from 'components/flex/FlexRow';
import ShareIcon from '!!react-svg-loader!../space-card/icons/icon--space-share.svg';
import React, { useEffect, useState } from 'react';
import C from './CommunityJoinLink.css';
import { Trans, msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import LinkIcon from '@mui/icons-material/Link';

export default function CommunityJoinLink(p: { communityId: string }) {
  const { _ } = useLingui();
  const { community } = useCommunityDetails({
    communityId: p.communityId,
  });

  const code = community?.genericInvitationCode?.code;
  const displayURL = `${location.origin}/#${code}`.replace(/^https?:\/\//, '');
  const [didCopyLink, setCopyLink] = useState(false);

  useEffect(() => {
    if (didCopyLink) {
      const timer = setTimeout(() => {
        setCopyLink(false);
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [didCopyLink]);

  return (
    <>
      {code && (
        <FlexRow className={C.inviteCodeSection} alignItems='center'>
          <Stack direction='row' alignItems='center'>
            <LinkIcon style={{ width: '2rem' }} />
            <Trans>Invite Link</Trans>:&nbsp;
            <span className={C.inviteCodeLink}>{displayURL}</span>
            <Tooltip
              title={didCopyLink ? _(msg`Copied Link`) : _(msg`Copy Link`)}
            >
              <Button
                className={C.mutedOutlineBtn}
                style={{ marginLeft: '10px', minWidth: 0 }}
                onClick={() => {
                  navigator.clipboard.writeText(`${location.origin}/#${code}`);
                  setCopyLink(true);
                }}
              >
                {didCopyLink ? (
                  <DoneIcon
                    style={{
                      width: '1rem',
                      fill: 'green',
                    }}
                  />
                ) : (
                  <ContentCopyIcon
                    style={{
                      width: '1rem',
                    }}
                  />
                )}
              </Button>
            </Tooltip>
          </Stack>
        </FlexRow>
      )}
    </>
  );
}
